import fetch from 'apiMiddleware';

export const login = data => fetch({
  method: 'POST',
  url: 'users/token-auth/',
  data
});

export const passwordReset = data => fetch({
  method: 'POST',
  url: 'users/password/reset/',
  data
});

export const passwordSet = data => fetch({
  method: 'POST',
  url: 'users/password/set/',
  data
});

export const passwordResetConfirm = data => fetch({
  method: 'POST',
  url: 'users/password/reset/confirm/',
  data
});

export const getMyProfile = () => fetch({
  method: 'GET',
  url: 'users/me/',
});

export const patchMyProfile = (data) => fetch({
  method: 'PATCH',
  url: 'users/me/',
  data
});

// export const getUsers = () => fetch({
//   method: 'GET',
//   url: 'users/users/',
// });

// export const patchUser = (id, data) => fetch({
//   method: 'PATCH',
//   url: `users/users/${id}/`,
//   data
// });


// WEBPACK FOOTER //
// ./src/api/users/calls.js